import { render, staticRenderFns } from "./PopupTaskEdit.vue?vue&type=template&id=3f0052f1"
import script from "./PopupTaskEdit.vue?vue&type=script&lang=ts"
export * from "./PopupTaskEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports